import { useEffect, useState } from 'react';
import XenieNewLogo from '../../../../Assets/XenieLogoDark.png';
import Search from '../../../../Assets/Modals/SearchIcon.svg';
import Bell from '../../../../Assets/StorefrontIcons/Bell.svg';
import Bag from '../../../../Assets/StorefrontIcons/Bag.svg';

import { useSelector } from 'react-redux';
import { getPostProfile } from '../../../../lib/utils/apiCalls';
import { getCachedMediaUrl, getInitials } from '../../../../lib/utils/utils';

function Navbar() {
    const [logoSize, setLogoSize] = useState(0);
    const [sideSpace, setSideSpace] = useState(0);
    const [navbarHeight, setNavbarHeight] = useState(0);
    const [ctaSize, setCTASize] = useState(0);

    const [searchBoxWidth, setSearchBoxWidth] = useState(0);
    const [searchBoxHeight, setSearchBoxHeight] = useState(0);
    const [searchButtonSize, setSearchButtonSize] = useState(0);
    const [searchTextSize, setSearchTextSize] = useState(0);
    const [searchLineHeight, setSearchLineHeight] = useState(0);

    const [linkTextSize, setLinkTextSize] = useState(0);
    const [linkLineHeight, setLinkLineHeight] = useState(0);
    const [linkGap, setLinkGap] = useState(0);
    const [barHeight, setBarHeight] = useState(0);
    const [buttonGap, setButtonGap] = useState(0);
    const [linkMargin, setLinkMargin] = useState(0);

    const [userButtonSize, setUserButtonSize] = useState(0);
    const [textSize, setTextSize] = useState(0);
    const [lineHeight, setLineHeight] = useState(0);

    const [userProfile, setUserProfile] = useState({});
    const user = useSelector((state) => state.user.user);

    useEffect(() => {
        const getUserProfile = async () => {
            const profile = await getPostProfile(user.SellerUserId);
            setUserProfile(profile);
        }
    
        setTimeout(() => {
            Object.keys(user).length > 0 && getUserProfile();
        }, 200);
    }, [user]);

    const zoomSize = useSelector((state) => state.storefront.zoomSize);

    useEffect(() => {
        setLogoSize((zoomSize/100)*74);
        setSideSpace((zoomSize/100)*28);
        setNavbarHeight((zoomSize/100)*45);
        setCTASize((zoomSize/100)*22);
        setUserButtonSize((zoomSize/100)*28);
        setTextSize((zoomSize/100)*9);
        setLineHeight((zoomSize/100)*12.41);

        setLinkTextSize((zoomSize/100)*9.02);
        setLinkLineHeight((zoomSize/100)*15.79);
        setLinkGap((zoomSize/100)*13.53);
        setBarHeight((zoomSize/100)*4.51);
        setButtonGap((zoomSize/100)*10.15);
        setLinkMargin((zoomSize/100)*45);

        setSearchBoxWidth((zoomSize/100)*225.56);
        setSearchBoxHeight((zoomSize/100)*22.56);
        setSearchButtonSize((zoomSize/100)*13.53);
        setSearchTextSize((zoomSize/100)*6.77);
        setSearchLineHeight((zoomSize/100)*13.53);
    }, [zoomSize]);

    return (
        <div style={{ paddingLeft: `${sideSpace}px`, paddingRight: `${sideSpace}px`, height: `${navbarHeight}px` }} className="w-full bg-[#F3F3F3] flex items-center">
            <div style={{ width: `${logoSize}px` }}>
                <img className='w-full h-auto' src={XenieNewLogo} alt="" />
            </div>

            <div style={{ fontSize: `${linkTextSize}px`, lineHeight: `${linkLineHeight}px`, gap: `${linkGap}px`, marginLeft: `${linkMargin}px` }} className="mt-auto flex items-center">
                <div style={{ gap: `${buttonGap}px` }} className="flex flex-col">
                    <p>Home</p>

                    <div style={{ height: `${barHeight}px` }}></div>
                </div>

                <div style={{ gap: `${buttonGap}px` }} className="flex flex-col">
                    <p>Stores</p>

                    <div style={{ height: `${barHeight}px` }} className='bg-primaryColor'></div>
                </div>

                <div style={{ gap: `${buttonGap}px` }} className="flex flex-col">
                    <p>Lens</p>

                    <div style={{ height: `${barHeight}px` }}></div>
                </div>

                <div style={{ gap: `${buttonGap}px` }} className="flex flex-col">
                    <p>DropTrack</p>

                    <div style={{ height: `${barHeight}px` }}></div>
                </div>
            </div>

            <div className="flex items-center gap-[6px] ml-auto">
                <div style={{ width: `${searchBoxWidth}px`, height: `${searchBoxHeight}px` }} className="rounded bg-[#E3E3E3] flex items-center gap-2 p-1">
                    <div style={{ width: `${searchButtonSize}px`, height: `${searchButtonSize}px` }} className="flex items-center justify-center">
                        <img className='size-3/4' src={Search} alt="" />
                    </div>

                    <p style={{ width: `calc(100% - ${searchButtonSize}px)`, fontSize: `${searchTextSize}px`, lineHeight: `${searchLineHeight}px` }} className='text-[#999999]'>Search product, brands and more...</p>
                </div>

                <div style={{ width: `${ctaSize}px`, height: `${ctaSize}px` }} className="rounded-full bg-[#EAEAEA] flex items-center justify-center">
                    <img className='size-1/2' src={Bell} alt="" />
                </div>

                <div style={{ width: `${ctaSize}px`, height: `${ctaSize}px` }} className="rounded-full bg-[#EAEAEA] flex items-center justify-center">
                    <img className='size-1/2' src={Bag} alt="" />
                </div>

                <div style={{ width: `${userButtonSize}px`, height: `${userButtonSize}px` }} className="rounded-full bg-[#E3E3E3] flex items-center justify-center overflow-hidden">
                    {
                        userProfile.ProfilePic ? 
                        <img className='size-full' src={getCachedMediaUrl(userProfile.ProfilePic)} alt={getInitials(userProfile.name || "")} /> : 
                        <p style={{ fontSize: `${textSize}px`, lineHeight: `${lineHeight}px` }} className='font-bold text-[#666666]'>{getInitials(userProfile.name || "")}</p>
                    }                    
                </div>
            </div>
        </div>
    );
}

export default Navbar;
